import './index.css';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getMatchDetailsById } from '../../actions/fantasy-cricket-action-types';
import { isMatchInDelay, getMatchDelayTime } from '../../utilities/helper';
import I18n from '../../utilities/locale';
import Text from '../text';
import { confirmAlert } from 'react-confirm-alert';
import Card from '../card';
import View from '../view';
import Button from '@mui/material/Button/Button';
import useTheme from '../../utilities/hooks/theme';

const calculateTimeLeft = (timeStamp: number) => {
  var dt = new Date();
  dt.setMinutes(dt.getMinutes());
  const difference = timeStamp - moment(dt).valueOf();
  let timeLeft: any = {};
  if (difference > 0) {
    timeLeft = {
      hours: Math.floor(difference / (1000 * 60 * 60)),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60)
    };
  }
  return timeLeft;
};

interface Props {
  style?: React.CSSProperties;
  onCalledDeadline?: any;
  isShowAlert: boolean;
  matchItem: any;
  screen?: string;
  gameType?: string;
}

const CountdownTimer = ({
  gameType = '',
  style,
  onCalledDeadline,
  isShowAlert,
  matchItem
}: Props) => {
  const { ComponentTheme: theme } = useTheme();
  const dispatch = useDispatch();
  const {
    _id: matchId = '',
    gameState: matchGameState = 0,
    status: _matchStatus = '',
    matchDelayed: _matchDelayed = false
    // startDate: time = ''
  } = matchItem;
  const time = moment(new Date()).add(5, 'hours').format();
  const [gameState, setGameState] = useState(matchGameState);
  const [matchStatus, setMatchStatus] = useState(_matchStatus);
  const [matchDelayed, setMatchDelayed] = useState(_matchDelayed);

  const initialTimestamp = isMatchInDelay({
    matchStatus,
    gameState,
    matchDelayed,
    gameType
  })
    ? moment(new Date()).valueOf() + getMatchDelayTime(time)
    : moment(time).valueOf();

  const [timeLeft, setTimeLeft] = useState(() => calculateTimeLeft(initialTimestamp));
  const [alertModal, setAlertModal] = useState(false);

  useEffect(() => {
    const id = setTimeLeftInterval();
    return () => clearInterval(id);
  }, []);

  const getMatchDetails = () => {
    dispatch(
      getMatchDetailsById({
        data: { id: matchId },
        callback: ({ result, error }: { result: any; error: any }) => {
          if (!error && result) {
            const { gameState = 0, status = '', matchDelayed } = result;
            setMatchStatus(status);
            setGameState(gameState);
            setMatchDelayed(matchDelayed);
            if (gameState != 4 && gameState != 0 && gameState != 1 && !matchDelayed) {
              alertForDeadline();
            }
          }
        }
      })
    );
  };

  const setTimeLeftInterval = () => {
    const id = setInterval(() => {
      const matchInDelay = isMatchInDelay({
        matchStatus,
        gameState,
        matchDelayed,
        gameType
      });

      let timeStamp = matchInDelay
        ? moment(new Date()).valueOf() + getMatchDelayTime(time)
        : moment(time).valueOf();
      let tmpTimeLeft = calculateTimeLeft(timeStamp);
      if (tmpTimeLeft.hours === undefined && matchInDelay) {
        timeStamp = moment(new Date()).valueOf() + getMatchDelayTime(time);
        tmpTimeLeft = calculateTimeLeft(timeStamp);
        getMatchDetails();
      } else if (tmpTimeLeft.hours === undefined && !alertModal) {
        clearInterval(id);
        alertForDeadline();
      }

      setTimeLeft(tmpTimeLeft);
    }, 1000);
    return id;
  };

  const alertForDeadline = () => {
    setAlertModal(true);
    if (isShowAlert) {
      confirmAlert({
        closeOnEscape: false,
        closeOnClickOutside: false,
        customUI: ({ onClose }) => {
          const onPressOk = () => {
            onClose();
            onCalledDeadline();
          };
          return (
            <Card
              style={{
                backgroundColor: theme.countDownTimerDeadlineBG
              }}
              className="countdown-timer-deadline-container">
              <Text
                style={{
                  color: theme.countDownTimerDeadlineMessage
                }}
                className={'countdown-timer-deadline-message'}>
                {I18n.t('MatchDeadlinedFinished')}
              </Text>
              <View className={'countdown-timer-deadline-button-container'}>
                <Button
                  style={{
                    backgroundColor: theme.countDownTimerDeadlineBtn,
                    color: theme.countDownTimerDeadlineBtnTitle
                  }}
                  className="countdown-timer-deadline-button"
                  onClick={onPressOk}>
                  {'ok'}
                </Button>
              </View>
            </Card>
          );
        }
      });
    } else {
      onCalledDeadline();
    }
  };

  if (timeLeft.hours === undefined)
    return (
      <Text className="countdown-timer" style={style}>
        {'0h:0m'}
      </Text>
    );

  const { hours, minutes, seconds } = timeLeft;
  return (
    <Text className="countdown-timer" style={style}>{`${hours}h : ${minutes}m : ${seconds}s`}</Text>
  );
};
export default React.memo(CountdownTimer);
